import { memo, ReactElement, ReactPortal, useEffect, useState } from 'react';
import { createPortal } from 'react-dom';

type PortalProps = {
  rootId?: string;
  children: ReactElement;
};

const _Portal = ({ rootId, children }: PortalProps): ReactPortal | null => {
  const [container, setContainer] = useState<HTMLElement | null>();

  useEffect(() => {
    setContainer(rootId ? document.getElementById(rootId) : document.body);
  }, [rootId]);

  return container ? createPortal(children, container) : null;
};

export const Portal = memo(_Portal);
